import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const benefits = ['Recetas reales y probadas', 'Medidas exactas (en gramos)', 'Pasos claros y sin secretos', 'Técnicas para una mejor fermentación', 'Secretos para un mejor formado', 'Panes más suaves, dorados y vendibles', 'Ideal para disfrutar en casa o para iniciar tu negocio'];
export function Benefits() {
  return <section className="py-24 bg-beige" data-id="element-14">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-15">
        <div className="bg-warm-white p-10 md:p-16 shadow-xl relative" data-id="element-16">
          <div className="absolute top-0 left-0 w-2 h-full bg-terracotta" data-id="element-17"></div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-12" data-id="element-18">
            <h2 className="text-4xl md:text-5xl font-bold text-espresso mb-4" data-id="element-19">
              Este ebook es diferente
            </h2>
            <p className="text-lg text-espresso/70 max-w-2xl mx-auto" data-id="element-20">
              No más improvisación. Aquí encontrarás la técnica panadera
              explicada de forma sencilla para que logres resultados
              profesionales en tu cocina.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-21">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-center gap-4" data-id="element-22">
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-bakery-brown/10 text-bakery-brown rounded-full" data-id="element-23">
                  <Check size={18} strokeWidth={2.5} data-id="element-24" />
                </div>
                <span className="text-lg text-espresso font-medium" data-id="element-25">
                  {benefit}
                </span>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="mt-16 text-center" data-id="element-26">
            <a href="#comprar" className="inline-block bg-terracotta text-cream px-10 py-4 font-medium tracking-wide hover:bg-espresso transition-colors duration-300 shadow-lg hover:shadow-xl" data-id="element-27">
              Quiero hornear mejor
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}